module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daythunderstorm-7c682e6bd86dd648fcee06e72f4ff8bd.svg";